import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { PostCardComponent } from "./post-card/post-card";
import { PostImageComponent } from "./post-image/post-image";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { PostContentComponent } from "./post-content/post-content.component";
import { NgxViewerModule } from "ngx-viewer";
import { FileDownloadComponent } from "./post-links/file-download.component";
import { ExternalUrlComponent } from "./post-links/external-url.component";
import { SanitizePipe } from "../sanitize.pipe";
@NgModule({
  declarations: [
    PostCardComponent,
    PostImageComponent,
    PostContentComponent,
    FileDownloadComponent,
    ExternalUrlComponent,
    SanitizePipe,
  ],
  imports: [IonicModule, FormsModule, CommonModule, RouterModule, NgxViewerModule],
  entryComponents: [],
  exports: [PostCardComponent, PostImageComponent, PostContentComponent, FileDownloadComponent, ExternalUrlComponent],
})
export class PostComponentsModule {}
